import { emailIdChangeAndBlur, postalCodeChange, phoneNumberChange, phoneNumberBlur, countryChange, phoneNumberClick, addressLine2OnChange, postalCodeBlur} from './formChangeHandler';
import { deliveryAddressLine1OnChange, billingAddressLine1OnChange, editDeliveryAddressLine1OnChange, editBillingAddressLine1OnChange } from './loqate';
declare const window: any;

const formFields = {
    "default": {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "county",
            "country"
        ],
        "formFieldSequence": [  
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["county","country"]
        ],
        "formFieldProps": {
            "email": {
                "isRequired": true,
                "fieldName": "email",
                "label": "checkout_shipping.email_address",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"validation.email",
                "value": ""
            },
            "phone": {
                "isRequired": true,
                "fieldName": "phone",
                "label":"address.phone",
                "placeholder": " ",
                "id":"",
                "type": "tel",
                "regex": "",
                "additionalCssClass": "phone prefix",
                "prefix": true,
                "prefixValue": "",
                "prefixClass": "tel-prefix",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"address.error_phone_soft_validation",
                "value": "",
                "maxLength": 40
            },
            "firstName": {
                "isRequired": true,
                "fieldName": "firstName",
                "label": "address.firstName",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "lastName": {
                "isRequired": true,
                "fieldName": "lastName",
                "label": "address.lastName",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "company": {
                "isRequired": false,
                "fieldName": "company",
                "label": "address.company",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "addressLine1": {
                "isRequired": true,
                "fieldName": "addressLine1",
                "label": "address.addressLine1",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": "",
                "maxLength": 30,
            },
            "addressLine2": {
                "isRequired": false,
                "fieldName": "addressLine2",
                "label": "address.addressLine2",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": "",
                "maxLength":30
            },
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "city": {
                "isRequired": true,
                "fieldName": "city",
                "label": "address.city",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "county": {
                "isRequired": true,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "country": {
                "isRequired": true,
                "fieldName": "country",
                "label": "address.country",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "isDisabled": false,
                "value": "",
                "listValues": [
                    {
                        "value": "IE",
                        "name": "Ireland"
                    },
                    {
                        "value": "GB",
                        "name": "United Kingdom"
                    },
                    {
                        "value": "PT",
                        "name": "Portugal"
                    },
                    {
                        "value": "ES",
                        "name": "Spain"
                    },
                    {
                        "value": "NL",
                        "name": "Netherlands"
                    },
                    {
                        "value": "BE",
                        "name": "Belgium"
                    },
                    {
                        "value": "FR",
                        "name": "France"
                    },
                    {
                        "value": "CH",
                        "name": "Switzerland"
                    },
                    {
                        "value": "DE",
                        "name": "Germany"
                    },
                    {
                        "value": "DK",
                        "name": "Denmark"
                    },
                    {
                        "value": "NO",
                        "name": "Norway"
                    },
                    {
                        "value": "SE",
                        "name": "Sweden"
                    },
                    {
                        "value": "FI",
                        "name": "Finland"
                    },
                    {
                        "value": "CZ",
                        "name": "Czech Republic"
                    },
                    {
                        "value": "AT",
                        "name": "Austria"
                    },
                    {
                        "value": "IT",
                        "name": "Italy"
                    },
                    {
                        "value": "HU",
                        "name": "Hungary"
                    },
                    {
                        "value": "SK",
                        "name": "Slovakia"
                    }
                ],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
            },
        }
    },
    "IE": {
        "formFieldProps": {
            "county": {
                "isRequired": false,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "listValues": [
                    {
                        "value": "Co.Carlow",
                        "name": "Carlow"
                    },
                    {
                        "value": "Co.Cavan",
                        "name": "Cavan"
                    },
                    {
                        "value": "Co.Clare",
                        "name": "Clare"
                    },
                    {
                        "value": "Co.Cork",
                        "name": "Cork"
                    },
                    {
                        "value": "Co.Donegal",
                        "name": "Donegal"
                    },
                    {
                        "value": "Co.Dublin",
                        "name": "Dublin"
                    },
                    {
                        "value": "Co.Galway",
                        "name": "Galway"
                    },
                    {
                        "value": "Co.Kerry",
                        "name": "Kerry"
                    },
                    {
                        "value": "Co.Kildare",
                        "name": "Kildare"
                    },
                    {
                        "value": "Co.Kilkenny",
                        "name": "Kilkenny"
                    },
                    {
                        "value": "Co.Laois",
                        "name": "Laois"
                    },
                    {
                        "value": "Co.Leitrim",
                        "name": "Leitrim"
                    },
                    {
                        "value": "Co.Limerick",
                        "name": "Limerick"
                    },
                    {
                        "value": "Co.Longford",
                        "name": "Longford"
                    },
                    {
                        "value": "Co.Louth",
                        "name": "Louth"
                    },
                    {
                        "value": "Co.Mayo",
                        "name": "Mayo"
                    },
                    {
                        "value": "Co.Meath",
                        "name": "Meath"
                    },
                    {
                        "value": "Co.Monaghan",
                        "name": "Monaghan"
                    },
                    {
                        "value": "Co.Offaly",
                        "name": "Offaly"
                    },
                    {
                        "value": "Co.Roscommon",
                        "name": "Roscommon"
                    },
                    {
                        "value": "Co.Sligo",
                        "name": "Sligo"
                    },
                    {
                        "value": "Co.Tipperary",
                        "name": "Tipperary"
                    },
                    {
                        "value": "Co.Tyrone",
                        "name": "Tyrone"
                    },
                    {
                        "value": "Co.Waterford",
                        "name": "Waterford"
                    },
                    {
                        "value": "Co.Westmeath",
                        "name": "Westmeath"
                    },
                    {
                        "value": "Co.Wexford",
                        "name": "Wexford"
                    },
                    {
                        "value": "Co.Wicklow",
                        "name": "Wicklow"
                    }
                ],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            }
        }
    },
    "PT": {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "addressLine1": {
                "isRequired": true,
                "fieldName": "addressLine1",
                "label": "address.addressLine1",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": "",
                "maxLength": 50
            },
            "addressLine2": {
                "isRequired": false,
                "fieldName": "addressLine2",
                "label": "address.addressLine2",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": "",
                "maxLength":50
            },
            "county": false
        }
    },
    "ES": {
        "formFieldProps": {
            "addressLine1": {
                "isRequired": true,
                "fieldName": "addressLine1",
                "label": "address.addressLine1",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": "",
                "maxLength": 50
            },
            "addressLine2": {
                "isRequired": false,
                "fieldName": "addressLine2",
                "label": "address.addressLine2",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": "",
                "maxLength":50
            },
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            }
        }
    },
    "BE": {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [  
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "county": false
        }
    },
    "GB": {
        "formFieldProps": {
            "county": {
                "isRequired": false,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "input",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            }
        }
    },
    "CH": {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "county": {
                "isRequired": false,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "input",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            }
        }
    },
    "NL" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "county": {
                "isRequired": false,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "input",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            }
        }
    },
    "FR" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "addressLine1": {
                "isRequired": true,
                "fieldName": "addressLine1",
                "label": "address.addressLine1",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": "",
                "maxLength": 50
            },
            "addressLine2": {
                "isRequired": false,
                "fieldName": "addressLine2",
                "label": "address.addressLine2",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": "",
                "maxLength":50
            },
            "county": false
        }
    },
    "DE" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "county": false
        }
    },
    "IT" :{
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "county",
            "country"
        ],
        "formFieldSequence": [  
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["county","country"]
        ],
        "formFieldProps": {
            "county": {
                "isRequired": true,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "listValues": [{ "value": "AG", "name": "AG" }, { "value": "AL", "name": "AL" }, { "value": "AN", "name": "AN" }, { "value": "AO", "name": "AO" }, { "value": "AP", "name": "AP" }, { "value": "AQ", "name": "AQ" }, { "value": "AR", "name": "AR" }, { "value": "AT", "name": "AT" }, { "value": "AV", "name": "AV" }, { "value": "BA", "name": "BA" }, { "value": "BG", "name": "BG" }, { "value": "BI", "name": "BI" }, { "value": "BL", "name": "BL" }, { "value": "BN", "name": "BN" }, { "value": "BO", "name": "BO" }, { "value": "BR", "name": "BR" }, { "value": "BS", "name": "BS" }, { "value": "BT", "name": "BT" }, { "value": "BZ", "name": "BZ" }, { "value": "CA", "name": "CA" }, { "value": "CB", "name": "CB" }, { "value": "CE", "name": "CE" }, { "value": "CH", "name": "CH" }, { "value": "CL", "name": "CL" }, { "value": "CN", "name": "CN" }, { "value": "CO", "name": "CO" }, { "value": "CR", "name": "CR" }, { "value": "CS", "name": "CS" }, { "value": "CT", "name": "CT" }, { "value": "CZ", "name": "CZ" }, { "value": "EN", "name": "EN" }, { "value": "FC", "name": "FC" }, { "value": "FE", "name": "FE" }, { "value": "FG", "name": "FG" }, { "value": "FI", "name": "FI" }, { "value": "FM", "name": "FM" }, { "value": "FR", "name": "FR" }, { "value": "GE", "name": "GE" }, { "value": "GO", "name": "GO" }, { "value": "GR", "name": "GR" }, { "value": "IM", "name": "IM" }, { "value": "IS", "name": "IS" }, { "value": "KR", "name": "KR" }, { "value": "LC", "name": "LC" }, { "value": "LE", "name": "LE" }, { "value": "LI", "name": "LI" }, { "value": "LO", "name": "LO" }, { "value": "LT", "name": "LT" }, { "value": "LU", "name": "LU" }, { "value": "MB", "name": "MB" }, { "value": "MC", "name": "MC" }, { "value": "ME", "name": "ME" }, { "value": "MI", "name": "MI" }, { "value": "MN", "name": "MN" }, { "value": "MO", "name": "MO" }, { "value": "MS", "name": "MS" }, { "value": "MT", "name": "MT" }, { "value": "NA", "name": "NA" }, { "value": "NO", "name": "NO" }, { "value": "NU", "name": "NU" }, { "value": "OR", "name": "OR" }, { "value": "PA", "name": "PA" }, { "value": "PC", "name": "PC" }, { "value": "PD", "name": "PD" }, { "value": "PE", "name": "PE" }, { "value": "PG", "name": "PG" }, { "value": "PI", "name": "PI" }, { "value": "PN", "name": "PN" }, { "value": "PO", "name": "PO" }, { "value": "PR", "name": "PR" }, { "value": "PT", "name": "PT" }, { "value": "PU", "name": "PU" }, { "value": "PV", "name": "PV" }, { "value": "PZ", "name": "PZ" }, { "value": "RA", "name": "RA" }, { "value": "RC", "name": "RC" }, { "value": "RE", "name": "RE" }, { "value": "RG", "name": "RG" }, { "value": "RI", "name": "RI" }, { "value": "RM", "name": "RM" }, { "value": "RN", "name": "RN" }, { "value": "RO", "name": "RO" }, { "value": "SA", "name": "SA" }, { "value": "SI", "name": "SI" }, { "value": "SO", "name": "SO" }, { "value": "SP", "name": "SP" }, { "value": "SR", "name": "SR" }, { "value": "SS", "name": "SS" }, { "value": "SU", "name": "SU" }, { "value": "SV", "name": "SV" }, { "value": "TA", "name": "TA" }, { "value": "TE", "name": "TE" }, { "value": "TN", "name": "TN" }, { "value": "TO", "name": "TO" }, { "value": "TP", "name": "TP" }, { "value": "TR", "name": "TR" }, { "value": "TS", "name": "TS" }, { "value": "TV", "name": "TV" }, { "value": "UD", "name": "UD" }, { "value": "VA", "name": "VA" }, { "value": "VB", "name": "VB" }, { "value": "VC", "name": "VC" }, { "value": "VE", "name": "VE" }, { "value": "VI", "name": "VI" }, { "value": "VR", "name": "VR" }, { "value": "VT", "name": "VT" }, { "value": "VV", "name": "VV" }],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            }
        }
    },
    "AT" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "county": false
        }
    },
    "DK" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "county": false
        }
    },
    "NO": {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "county": {
                "isRequired": false,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "input",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            }
        }
    },
    "FI" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "county": false
        }
    },
    "SE" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "county": false
        }
    },
    "CZ" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "county": false
        }
    },
    "HU" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "county": false
        }
    },
    "SK" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "country"
        ],
        "formFieldSequence": [
            ["email"],
            ["firstName","lastName"],
            ["company"],
            ["phone"],
            ["addressLine1"],
            ["addressLine2"],
            ["postalCode","city"],
            ["country"]
        ],
        "formFieldProps": {
            "county": false
        }
    },
    "JP" : {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "county"
        ],
        "formFieldSequence": [  
            ["lastName", "firstName"],
            ["company"],
            ["phone"],
            ["postalCode"],
            ["county", "city"],
            ["addressLine1"],
            ["addressLine2"]
        ],
        "formFieldProps": {
            "county": {
                "isRequired": true,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "listValues": [
                    { "value": "北海道", "name": "北海道" },
                    { "value": "青森県", "name": "青森県" },
                    { "value": "岩手県", "name": "岩手県" },
                    { "value": "宮城県", "name": "宮城県" },
                    { "value": "秋田県", "name": "秋田県" },
                    { "value": "山形県", "name": "山形県" },
                    { "value": "福島県", "name": "福島県" },
                    { "value": "茨城県", "name": "茨城県" },
                    { "value": "栃木県", "name": "栃木県" },
                    { "value": "群馬県", "name": "群馬県" },
                    { "value": "埼玉県", "name": "埼玉県" },
                    { "value": "千葉県", "name": "千葉県" },
                    { "value": "東京都", "name": "東京都" },
                    { "value": "神奈川県", "name": "神奈川県" },
                    { "value": "新潟県", "name": "新潟県" },
                    { "value": "富山県", "name": "富山県" },
                    { "value": "石川県", "name": "石川県" },
                    { "value": "福井県", "name": "福井県" },
                    { "value": "山梨県", "name": "山梨県" },
                    { "value": "長野県", "name": "長野県" },
                    { "value": "岐阜県", "name": "岐阜県" },
                    { "value": "静岡県", "name": "静岡県" },
                    { "value": "愛知県", "name": "愛知県" },
                    { "value": "三重県", "name": "三重県" },
                    { "value": "滋賀県", "name": "滋賀県" },
                    { "value": "京都府", "name": "京都府" },
                    { "value": "大阪府", "name": "大阪府" },
                    { "value": "兵庫県", "name": "兵庫県" },
                    { "value": "奈良県", "name": "奈良県" },
                    { "value": "和歌山県", "name": "和歌山県" },
                    { "value": "鳥取県", "name": "鳥取県" },
                    { "value": "島根県", "name": "島根県" },
                    { "value": "岡山県", "name": "岡山県" },
                    { "value": "広島県", "name": "広島県" },
                    { "value": "山口県", "name": "山口県" },
                    { "value": "徳島県", "name": "徳島県" },
                    { "value": "香川県", "name": "香川県" },
                    { "value": "愛媛県", "name": "愛媛県" },
                    { "value": "高知県", "name": "高知県" },
                    { "value": "福岡県", "name": "福岡県" },
                    { "value": "佐賀県", "name": "佐賀県" },
                    { "value": "長崎県", "name": "長崎県" },
                    { "value": "熊本県", "name": "熊本県" },
                    { "value": "大分県", "name": "大分県" },
                    { "value": "宮崎県", "name": "宮崎県" },
                    { "value": "鹿児島県", "name": "鹿児島県" },
                    { "value": "沖縄県", "name": "沖縄県" }
                ],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "country": {
                "isRequired": true,
                "fieldName": "country",
                "label": "address.country",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "isDisabled": true,
                "value": "JP",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
            }
        }
    },
    "AU": {
        "formFieldProps": {
            "county": {
                "isRequired": true,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "listValues": [
                    { "value": "ACT", "name": "ACT" },
                    { "value": "WA", "name": "WA" },
                    { "value": "SA", "name": "SA" },
                    { "value": "NT", "name": "NT" },
                    { "value": "QLD", "name": "QLD" },
                    { "value": "NSW", "name": "NSW" },
                    { "value": "VIC", "name": "VIC" },
                    { "value": "TAS", "name": "TAS" }
                ],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "country": {
                "isRequired": true,
                "fieldName": "country",
                "label": "address.country",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "isDisabled": true,
                "value": "",
                "listValues": [
                    {
                        "value": "AU",
                        "name": "Australia"
                    }
                ],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
            }
        }
    },
    "NZ": {
        "formFieldProps": {
            "county": {
                "isRequired": false,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "country": {
                "isRequired": true,
                "fieldName": "country",
                "label": "address.country",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "isDisabled": true,
                "value": "",
                "listValues": [
                    {
                        "value": "NZ",
                        "name": "New Zealand"
                    }
                ],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
            }
        }
    },
    "US": {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "extension",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "county"
        ],
        "formFieldSequence": [  
            ["email"],
            ["firstName", "lastName"],
            ["company"],
            ["phone", "extension"],
            ["addressLine1"],
            ["addressLine2"],
            ["city"],
            ["county"],
            ["postalCode"]
        ],
        "formFieldProps": {
            "addressLine1": {
                "isRequired": true,
                "fieldName": "addressLine1",
                "label": "address.addressLine1",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"checkout_shipping.pOBoxWarningText",
                "value": "",
                "maxLength": 30,
            },
            "addressLine2": {
                "isRequired": false,
                "fieldName": "addressLine2",
                "label": "address.addressLine2",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"checkout_shipping.pOBoxWarningText",
                "value": "",
                "maxLength":30
            },
            "phone": {
                "isRequired": true,
                "fieldName": "phone",
                "label":"address.phone",
                "placeholder": " ",
                "id":"",
                "inputType": "tel",
                "type":"phoneMask",
                "regex": "",
                "mask" : "(999) 999-9999",
                "additionalCssClass": "phone",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "extension": {
                "isRequired": false,
                "fieldName": "extension",
                "label": "Extension",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^[a-zA-Z0-9]+$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "maxLength": 7,
                "value": ""
            },
            "county": {
                "isRequired": true,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "listValues": [
                    {"value": "AK", "name": "AK - Alaska" },
                    {"value": "AL", "name": "AL - Alabama" },
                    {"value": "AR", "name": "AR - Arkansas" },
                    {"value": "AZ", "name": "AZ - Arizona" },
                    {"value": "CA", "name": "CA - California" },
                    {"value": "CO", "name": "CO - Colorado" },
                    {"value": "CT", "name": "CT - Connecticut" },
                    {"value": "DC", "name": "DC - District of Columbia" },
                    {"value": "DE", "name": "DE - Delaware" },
                    {"value": "FL", "name": "FL - Florida" },
                    {"value": "GA", "name": "GA - Georgia" },
                    {"value": "GU", "name": "GU - Guam" },
                    {"value": "HI", "name": "HI - Hawaii" },
                    {"value": "IA", "name": "IA - Iowa" },
                    {"value": "ID", "name": "ID - Idaho" },
                    {"value": "IL", "name": "IL - Illinois" },
                    {"value": "IN", "name": "IN - Indiana" },
                    {"value": "KS", "name": "KS - Kansas" },
                    {"value": "KY", "name": "KY - Kentucky" },
                    {"value": "LA", "name": "LA - Louisiana" },
                    {"value": "MA", "name": "MA - Massachusetts" },
                    {"value": "MD", "name": "MD - Maryland" },
                    {"value": "ME", "name": "ME - Maine" },
                    {"value": "MI", "name": "MI - Michigan" },
                    {"value": "MN", "name": "MN - Minnesota" },
                    {"value": "MO", "name": "MO - Missouri" },
                    {"value": "MS", "name": "MS - Mississippi" },
                    {"value": "MT", "name": "MT - Montana" },
                    {"value": "NC", "name": "NC - North Carolina" },
                    {"value": "ND", "name": "ND - North Dakota" },
                    {"value": "NE", "name": "NE - Nebraska" },
                    {"value": "NH", "name": "NH - New Hampshire" },
                    {"value": "NJ", "name": "NJ - New Jersey" },
                    {"value": "NM", "name": "NM - New Mexico" },
                    {"value": "NV", "name": "NV - Nevada" },
                    {"value": "NY", "name": "NY - New York" },
                    {"value": "OH", "name": "OH - Ohio" },
                    {"value": "OK", "name": "OK - Oklahoma" },
                    {"value": "OR", "name": "OR - Oregon" },
                    {"value": "PA", "name": "PA - Pennsylvania" },
                    {"value": "PR", "name": "PR - Puerto Rico" },
                    {"value": "RI", "name": "RI - Rhode Island" },
                    {"value": "SC", "name": "SC - South Carolina" },
                    {"value": "SD", "name": "SD - South Dakota" },
                    {"value": "TN", "name": "TN - Tennessee" },
                    {"value": "TX", "name": "TX - Texas" },
                    {"value": "UT", "name": "UT - Utah" },
                    {"value": "VA", "name": "VA - Virginia" },
                    {"value": "VT", "name": "VT - Vermont" },
                    {"value": "WA", "name": "WA - Washington" },
                    {"value": "WI", "name": "WI - Wisconsin" },
                    {"value": "WV", "name": "WV - West Virginia" },
                    {"value": "WY", "name": "WY - Wyoming" }
                ],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "country": {
                "isRequired": true,
                "fieldName": "country",
                "label": "address.country",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "isDisabled": true,
                "value": "US",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
            },
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "tel",
                "regex": "^[0-9]{5}(-[0-9]{4})?$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"address.error_postalCode",
                "maxLength": 10,
                "value": ""
            }
        }
    },
    "CA": {
        "formFieldNames": [
            "email",
            "firstName",
            "lastName",
            "company",
            "phone",
            "extension",
            "addressLine1",
            "addressLine2",
            "postalCode",
            "city",
            "county"
        ],
        "formFieldSequence": [  
            ["email"],
            ["firstName", "lastName"],
            ["company"],
            ["phone", "extension"],
            ["addressLine1"],
            ["addressLine2"],
            ["city"],
            ["county"],
            ["postalCode"]
        ],
        "formFieldProps": {
            "phone": {
                "isRequired": true,
                "fieldName": "phone",
                "label":"address.phone",
                "placeholder": " ",
                "id":"",
                "inputType": "tel",
                "type":"phoneMask",
                "mask" : "(999) 999-9999",
                "regex": "",
                "additionalCssClass": "phone",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "extension": {
                "isRequired": false,
                "fieldName": "extension",
                "label": "Extension",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^[a-zA-Z0-9]+$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "maxLength": 7,
                "value": ""
            },
            "county": {
                "isRequired": true,
                "fieldName": "county",
                "label": "address.county",
                "placeholder": " ",
                "id":"",
                "type": "list",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "listValues": [ 
                    { "value": "AB", "name": "Alberta" },
                    { "value": "BC", "name": "British Columbia" },
                    { "value": "MB", "name": "Manitoba" },
                    { "value": "NB", "name": "New Brunswick" },
                    { "value": "NL", "name": "Newfoundland and Labrador" },
                    { "value": "NT", "name": "Northwest Territories" },
                    { "value": "NS", "name": "Nova Scotia" },
                    { "value": "NU", "name": "Nunavut" },
                    { "value": "ON", "name": "Ontario" },
                    { "value": "PE", "name": "Prince Edward Island" },
                    { "value": "QC", "name": "Quebec" },
                    { "value": "SK", "name": "Saskatchewan" },
                    { "value": "YT", "name": "Yukon Territory" }
                ],
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
                "value": ""
            },
            "country": {
                "isRequired": true,
                "fieldName": "country",
                "label": "address.country",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^(.*)$",
                "additionalCssClass": "",
                "isDisabled": true,
                "value": "CA",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"",
            },
            "postalCode": {
                "isRequired": true,
                "fieldName": "postalCode",
                "label": "address.postalCode",
                "placeholder": " ",
                "id":"",
                "type": "text",
                "regex": "^[a-zA-Z0-9]{3}\\s[a-zA-Z0-9]{3}$",
                "highlightErrorField":false,
                "showMsg": false,
                "message":"address.error_postalCode",
                "maxLength": 7,
                "value": ""
            }
        }
    }
}

const vatIdProps = {
    "isRequired": false,
    "fieldName": "vatId",
    "label": "checkout_shipping.vat_label",
    "placeholder": " ",
    "id":"",
    "type": "text",
    "regex": "^(.*)$",
    "additionalCssClass": "tax-registration-number",
    "highlightErrorField":false,
    "showMsg": false,
    "message":"checkout_shipping.invalid_vat",
    "value": ""
}
const onChangeHandlers = {
    'delivery-address-addressLine1' : deliveryAddressLine1OnChange,
    'billing-address-addressLine1': billingAddressLine1OnChange,
    'edit-delivery-address-addressLine1':editDeliveryAddressLine1OnChange,
    'edit-billing-address-addressLine1':editBillingAddressLine1OnChange,
    'delivery-address-addressLine2' :addressLine2OnChange,
    'edit-delivery-address-addressLine2' :addressLine2OnChange,
    'delivery-address-postalCode' : postalCodeChange,
    'billing-address-postalCode' : postalCodeChange,
    'edit-delivery-address-postalCode' : postalCodeChange,
    'edit-billing-address-postalCode' : postalCodeChange,
    'delivery-address-phone' : phoneNumberChange,
    'billing-address-phone' : phoneNumberChange,
    'edit-delivery-address-phone' : phoneNumberChange,
    'edit-billing-address-phone' : phoneNumberChange,
    'delivery-address-country' :countryChange,
    'edit-delivery-address-country':countryChange,
    'delivery-address-email' : emailIdChangeAndBlur,
}

const onBlurHandlers = {
    'delivery-address-email' : emailIdChangeAndBlur,
    'delivery-address-phone' : phoneNumberBlur,
    'billing-address-phone' : phoneNumberBlur,
    'edit-delivery-address-phone' : phoneNumberBlur,
    'edit-billing-address-phone' : phoneNumberBlur,
    'delivery-address-postalCode' : postalCodeBlur,
}

const onClickHandlers = {
    'delivery-address-phone' : phoneNumberClick,
    'billing-address-phone' : phoneNumberClick,
    'edit-delivery-address-phone' : phoneNumberClick,
    'edit-billing-address-phone' : phoneNumberClick,
}

export {
    formFields,
    vatIdProps,
    onChangeHandlers,
    onBlurHandlers,
    onClickHandlers
};